import { nanoid } from "nanoid";

export const generateID = () => {
  return nanoid()
    .substring(0, 6)
    .replace("_", Math.floor(Math.random() * 10));
};
